import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

export class Component extends BaseComponent {

    render({ price }) {
        if (!price ) {
            return (
                <sale-message />
            );
        }

        let message = '';
        if (price.usd && price.usd.message) {
            message = price.usd.message;
        } else if (price.kc && price.kc.message) {
            message = price.kc.message;
        } else {
            return (
                <sale-message />
            );
        }

        return (
            <sale-message>
                <p class='sale-msg' dangerouslySetInnerHTML={{__html: message}} />
            </sale-message>
        );
    }
}

const mapStateToProps = (state) => ({
    price: state.product.price,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/sale-message.js